<template>
  <OverlayBadge
    v-if="showIncompleteProfileBadge"
    value="!"
    severity="warn"
    class="inline-flex"
  >
    <Avatar :label="userInitials" shape="circle" />
  </OverlayBadge>
  <Avatar v-else :label="userInitials" shape="circle" />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useUserStore } from "~/store/user";

const userStore = useUserStore();

const userInitials = computed(() => {
  const user = userStore.user;
  if (!user) return "U";

  const firstName = user.first_name?.charAt(0)?.toUpperCase() || "";
  const lastName = user.last_name?.charAt(0)?.toUpperCase() || "";
  let userTypeLabel = "";
  if (user.user_type) {
    if (typeof user.user_type === "string") userTypeLabel = user.user_type;
    else userTypeLabel = user.user_type.label || user.user_type.value || "";
  }

  if (firstName && lastName) {
    return firstName + lastName;
  } else if (firstName) {
    return firstName;
  } else if (userTypeLabel) {
    return userTypeLabel.substring(0, 2);
  }

  return "U";
});

const showIncompleteProfileBadge = computed(() => {
  const user = userStore.user;
  if (!user) return false;

  return !user.first_name || !user.last_name;
});
</script>
